module.exports = __webpack_public_path__ + "static/ascend-551a89359b0f4b06fdc34efbd065be1d.jpg";